import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';

const REFRESH_INTERVAL = 5 * 60 * 1000;
const RETRY_DELAY = 60 * 1000;

export const useSessionRefresh = () => {
  const { isAuthenticated, refreshSession } = useAuth();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const retryTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
        retryTimeoutRef.current = null;
      }
      return;
    }

    const refresh = async () => {
      try {
        await refreshSession();
      } catch (error) {
        console.error('Session refresh failed, retrying in 1 minute:', error);
        if (retryTimeoutRef.current) {
          clearTimeout(retryTimeoutRef.current);
        }
        retryTimeoutRef.current = setTimeout(refresh, RETRY_DELAY);
      }
    };

    intervalRef.current = setInterval(refresh, REFRESH_INTERVAL);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, [isAuthenticated, refreshSession]);
};
